import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { type AppDispatch, type AppState } from "../../../store/Store";
import {
  getParticipantById,
  updateParticipantStatus,
  printTicket,
  updateParticipant,
  updateCompany,
  getSearchedCompanies,
  getCompanyById,
} from "../modules/actions";
import { getPackagePricing } from "../../Dashboard/modules/actions";

const mapStateToProps = (state: AppState) => ({
  state: {
    currentParticipant: state.participantsReducer.currentParticipant,
    currentCompany: state.participantsReducer.currentCompany,
    packagePricing: state.dashboardReducer.packagePricing,
    searchedCompanies: state.participantsReducer.searchedCompanies,
    loading: state.participantsReducer.loading,
  },
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators(
    {
      updateCompany,
      getPackagePricing,
      getParticipantById,
      updateParticipant,
      updateParticipantStatus,
      printTicket,
      getCompanyById,
      getSearchedCompanies,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
